<template>
  <div class="invoice-normal-details">
    <div class="container-fluid">
      <div class="invoice-logo text-center">
        <div v-if="invoiceDetails.fatura_id != null">
          <!-- <img
            :src="require('../images/logo.png')"
            style="height: 56px; width: 56px"
            class="img-fluid"
            alt=""
          /> -->
        </div>
        <div class="inventory-logo">
          <img :src="img" style="width:60px; height:50px" class="img-fluid" alt="" />
        </div>
      </div>
      <div class="invoice-normal-details__header">
        <h4 class="text-center mt-0 mb-0 pt-0">بيان</h4>
        <div v-if="invoiceDetails != null">
          <table class="invoice-normal-details__header-table">
            <tr>
              <td>مسلسل :</td>
              <td>{{ invoiceDetails.id }}</td>
              <td>التاريخ :</td>
              <td>
                {{ invoiceDetails.created_at | moment("Do / MM / YYYY") }}
              </td>
            </tr>
            <tr>
              <td v-if="title.includes('مبيعات')">اسم العميل :</td>
              <td v-if="title.includes('مبيعات')">
                {{ invoiceDetails.customer.name }}
              </td>
              <td v-if="title.includes('شراء')">اسم المورد :</td>
              <td v-if="title.includes('شراء')">
                {{ invoiceDetails.supplier.name }}
              </td>
              <td>الساعه :</td>
              <td>{{ invoiceDetails.created_at | moment("h:mm A") }}</td>
            </tr>
          </table>
          <table class="invoice-normal-details__products-table">
            <thead>
              <tr>
                <th>#</th>
                <th>اسم الصنف</th>
                <th colspan="2">العدد</th>
                <th>السعر</th>
                <th>الاجمالي</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, index) in invoiceDetails.products"
                :key="product.id"
              >
                <template v-if="invoiceType === 'sales'">
                  <template
                    v-if="
                      Number(product.pivot.qty) -
                        Number(product.pivot.returned_qty) >
                      0
                    "
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ product.name }}</td>
                    <td>
                      <div v-if="Number(product.pivot.unit_type) == 2">
                        {{
                          Number(product.pivot.qty) -
                          Number(product.pivot.returned_qty)
                        }}
                      </div>
                      <div v-else></div>
                    </td>
                    <td>
                      <div v-if="Number(product.pivot.unit_type) == 1">
                        {{
                          Number(product.pivot.qty) -
                          Number(product.pivot.returned_qty)
                        }}
                      </div>
                      <div v-else></div>
                    </td>
                    <td>
                      <div v-if="title.includes('مبيعات')">
                        {{ product.pivot.sale_price }}
                      </div>
                      <div v-if="title.includes('شراء')">
                        {{ product.pivot.buy_cost }}
                      </div>
                    </td>
                    <td>
                      <div v-if="title.includes('مبيعات')">
                        {{
                          numberToFixed(
                            (Number(product.pivot.qty) -
                              Number(product.pivot.returned_qty)) *
                              Number(product.pivot.sale_price)
                          )
                        }}
                      </div>
                      <div v-if="title.includes('شراء')">
                        {{
                          numberToFixed(
                            (Number(product.pivot.qty) -
                              Number(product.pivot.returned_qty)) *
                              Number(product.pivot.buy_cost)
                          )
                        }}
                      </div>
                    </td>
                  </template>
                </template>
                <template v-else>
                  <td>{{ index + 1 }}</td>
                  <td>{{ product.name }}</td>
                  <td>
                    <div v-if="Number(product.pivot.unit_type) == 2">
                      {{ product.pivot.qty }}
                    </div>
                    <div v-else></div>
                  </td>
                  <td>
                    <div v-if="Number(product.pivot.unit_type) == 1">
                      {{ product.pivot.qty }}
                    </div>
                    <div v-else></div>
                  </td>
                  <td>
                    <div v-if="title.includes('مبيعات')">
                      {{ product.pivot.sale_price }}
                    </div>
                    <div v-if="title.includes('شراء')">
                      {{ product.pivot.buy_cost }}
                    </div>
                  </td>
                  <td>
                    <div v-if="title.includes('مبيعات')">
                      {{
                        numberToFixed(
                          Number(product.pivot.qty) *
                            Number(product.pivot.sale_price)
                        )
                      }}
                    </div>
                    <div v-if="title.includes('شراء')">
                      {{
                        numberToFixed(
                          Number(product.pivot.qty) *
                            Number(product.pivot.buy_cost)
                        )
                      }}
                    </div>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
          <div class="content">
            <el-row justify="between" class="full-width">
              <el-col :span="6">
                <table class="total-qty">
                  <tr>
                    <td style="white-space: nowrap">عدد الأصناف الرئسية</td>
                    <td width="15%">{{ totalMainQty }}</td>
                  </tr>
                  <tr>
                    <td style="white-space: nowrap">عدد الأصناف الفرعية</td>
                    <td width="15%">{{ totalSubQty }}</td>
                  </tr>
                </table>
              </el-col>
              <el-col :span="6" style="margin-right: auto">
                <table class="paymentDitals">
                  <tr>
                    <td style="white-space: nowrap">رصيد سابق</td>
                    <td v-if="invoiceDetails.paied_amount != undefined">
                      <div v-if="title.includes('مبيعات')">
                        {{
                          numberToFixed(
                            numberToFixed(
                              Number(invoiceDetails.customer.balance) +
                                Number(invoiceDetails.customer.account) +
                                Number(invoiceDetails.paied_amount)
                            ) -
                              numberToFixed(
                                Number(invoiceDetails.total_cost) -
                                  Number(invoiceDetails.returned_amount) -
                                  Number(invoiceDetails.discount)
                              )
                          )
                        }}
                      </div>
                      <div v-if="title.includes('شراء')">
                        {{
                          numberToFixed(
                            numberToFixed(
                              Number(invoiceDetails.supplier.balance) +
                                Number(invoiceDetails.supplier.account) +
                                Number(invoiceDetails.paied_amount)
                            ) -
                              numberToFixed(
                                Number(invoiceDetails.total_cost) -
                                  Number(invoiceDetails.discount)
                              )
                          )
                        }}
                      </div>
                    </td>

                    <td v-else>
                      <div v-if="title.includes('مبيعات')">
                        {{
                          numberToFixed(
                            numberToFixed(
                              Number(invoiceDetails.customer.balance) +
                                Number(invoiceDetails.customer.account)
                            ) -
                              numberToFixed(
                                Number(invoiceDetails.total_cost) -
                                  Number(invoiceDetails.discount)
                              )
                          )
                        }}
                      </div>
                      <div v-if="title.includes('شراء')">
                        {{
                          numberToFixed(
                            numberToFixed(
                              Number(invoiceDetails.supplier.balance) +
                                Number(invoiceDetails.supplier.account)
                            ) -
                              numberToFixed(
                                Number(invoiceDetails.total_cost) -
                                  Number(invoiceDetails.discount)
                              )
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                  <template v-if="invoiceDetails.discount > 0">
                    <tr>
                      <td style="white-space: nowrap">الفاتورة قبل الخصم</td>
                      <td v-if="invoiceType === 'sales'">
                        {{
                          Number(invoiceDetails.total_cost) -
                          Number(invoiceDetails.returned_amount)
                        }}
                      </td>
                      <td v-else>{{ invoiceDetails.total_cost }}</td>
                    </tr>
                    <tr>
                      <td>الخصم</td>
                      <td>{{ invoiceDetails.discount }}</td>
                    </tr>
                    <tr>
                      <td style="white-space: nowrap">الفاتورة بعد الخصم</td>
                      <td v-if="invoiceType === 'sales'">
                        {{
                          Number(invoiceDetails.total_cost) -
                          Number(invoiceDetails.returned_amount) -
                          Number(invoiceDetails.discount)
                        }}
                      </td>
                      <td v-else>
                        {{
                          Number(invoiceDetails.total_cost) -
                          Number(invoiceDetails.discount)
                        }}
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td>الفاتورة</td>
                      <td>
                        <template v-if="invoiceType === 'sales'">
                          {{
                            Number(invoiceDetails.total_cost) -
                            Number(invoiceDetails.returned_amount) -
                            Number(invoiceDetails.discount)
                          }}
                        </template>
                        <template v-else>
                          {{
                            Number(invoiceDetails.total_cost) -
                            Number(invoiceDetails.discount)
                          }}
                        </template>
                      </td>
                    </tr>
                  </template>

                  <tr
                    v-if="
                      invoiceDetails.paied_amount != undefined &&
                      invoiceDetails.paied_amount
                    "
                  >
                    <td>المدفوع</td>
                    <td>{{ invoiceDetails.paied_amount }}</td>
                  </tr>
                  <tr>
                    <td>الرصيد</td>
                    <td>
                      <div v-if="title.includes('مبيعات')">
                        {{
                          numberToFixed(
                            Number(invoiceDetails.customer.balance) +
                              Number(invoiceDetails.customer.account)
                          )
                        }}
                      </div>
                      <div v-if="title.includes('شراء')">
                        {{
                          numberToFixed(
                            Number(invoiceDetails.supplier.balance) +
                              Number(invoiceDetails.supplier.account)
                          )
                        }}
                      </div>
                    </td>
                  </tr>
                </table>
              </el-col>
            </el-row>
            <table class="result">
              <tr>
                <td v-if="title.includes('مبيعات')">
                  {{
                    Number(invoiceDetails.customer.balance) > 0
                      ? "مدين"
                      : "دائن"
                  }}
                </td>
                <td v-if="title.includes('شراء')">
                  {{
                    Number(invoiceDetails.supplier.balance) > 0
                      ? "دائن"
                      : "مدين"
                  }}
                </td>
                <td>
                  <div v-if="title.includes('مبيعات')">
                    {{
                      numberToString(
                        Number(invoiceDetails.customer.balance) +
                          Number(invoiceDetails.customer.account)
                      ) +
                      " " +
                      "فقط لا غير "
                    }}
                  </div>
                  <div v-if="title.includes('شراء')">
                    {{
                      numberToString(
                        Number(invoiceDetails.supplier.balance) +
                          Number(invoiceDetails.supplier.account)
                      ) +
                      " " +
                      "فقط لا غير "
                    }}
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { ipcRenderer } from "electron";
// window.ipcRenderer = ipcRenderer;
var writtenNumber = require("written-number");
writtenNumber.defaults.lang = "ar";
export default {
  props: [
    "invoiceDetails",
    "totalMainQty",
    "totalSubQty",
    "title",
    "invoiceType",
    "img",
  ],
  methods: {
    numberToFixed(number) {
      let num = Number(number);
      return Math.floor(num * 100) / 100;
    },
    numberToString(number) {
      if (number < 0) {
        number = number * -1;
      }
      return writtenNumber(number);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_color.scss";
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Open+Sans:wght@400;600;700&display=swap");
body {
  font-family: cairo !important;
}
.bg-w {
  margin: 0;
  padding: 0;
}
.content {
  padding: 22px 18px !important;
  .row {
    justify-content: space-between;
  }
  .header-item {
    width: fit-content;
    font-size: 10px;
  }
  .title {
    font-weight: bold;
  }
}
.header-of-page {
  background-color: #f7f8fa;
  .p-3 {
    padding: 22px 18px !important;
  }
  .logo {
    width: 18%;
    .img-fluid {
      width: 56px;
      height: 56px;
    }
  }
  .center {
    .logo {
      height: 47px;
      width: 75px;
    }
  }
  .content {
    .row {
      justify-content: space-between;
    }
    .header-item {
      width: fit-content;
    }
    .title {
      font-weight: bold;
    }
  }
  .border {
    width: 100%;
    padding: 13px 8px;
    border-top: 1px solid #fff;
    .first,
    .second {
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: 600;
      display: flex;
      align-items: center;
      margin-left: 22px;
      .icon {
        font-size: 7px;
        color: #d8d8d8;
      }
      P {
        text-align: center !important;
        width: 96%;
      }
    }
    .first {
      width: 45%;
    }
    .second {
      width: 35%;
    }
    .third {
      width: 25%;
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: 600;
      display: flex;
      align-items: center;
      .icon {
        font-size: 4px;
        color: #d8d8d8;
      }
    }
  }
}
.bg-whi {
  width: 100%;
  height: 21vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .firstDiv {
    background-color: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    width: 95%;
    height: 19vh;
    .thead {
      background-color: #f2f3f5;
      height: 8vh;
      width: 100%;
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: bold;
    }
    .tbody {
      background-color: $subColor;
      height: 8vh;
      width: 100%;
      color: #000000;
      font-family: Cairo;
      font-size: 12px;
      font-weight: bold;
    }
    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.footer-of-page {
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 28px;
  background: #f7f8fa;
  p {
    font-family: Cairo;
    font-size: 8px;
  }
}
table {
  width: 100%;
  border: 1px solid;
  border-collapse: collapse;
  th {
    border: 1px solid;
  }
  td {
    border: 1px solid #000000;
    padding: 5px 10px;
  }
}
.table {
  margin: 1rem auto;
  width: 95%;
  border-collapse: collapse;
  font-size: 13px !important;
  thead {
    padding: 10px;
    tr {
      th {
        padding: 1rem 0.5rem 1rem 0;
        .cell {
          font-weight: normal !important;
          color: #000000;
          font-family: Cairo;
          font-size: 12px !important;
          font-weight: 600;
          display: flex;
        }
      }
    }
  }
  tbody {
    tr {
      td {
        text-align: right;
        padding: 17px;
        margin-bottom: 0.5rem;
        background: #f7f7f7;
        .cell {
          font-weight: normal !important;
          height: 70px;
          color: #000000;
          font-family: Cairo;
          font-size: 10px;
          font-weight: 600;
          display: flex !important;
          &.bg-gray {
            background-color: #e5e5e5;
          }
          &.bg-Lightgray {
            background-color: #f7f8fa;
            border: 1px solid #fff;
          }
        }
      }
    }
  }
  tr,
  td {
    line-height: 1.7;
    text-align: right;
  }
  tfoot {
    border: none;
    tr {
      height: 30px;
      border: none;
    }
  }
}
.pb-2 {
  padding-bottom: 1rem;
}
.text-center {
  text-align: center;
}
.align-center {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Open Sans" !important;
}
.d-none {
  display: none;
}
.mt {
  margin-top: 182px;
}
.onlyAlign {
  display: flex;
  align-items: center;
  padding-right: 0.5rem;
}
.pb-1 {
  margin-bottom: 0.5rem;
}
.mr-auto {
  margin-right: auto;
}
.pr-1 {
  padding-right: 0.5rem;
}
.d-flex {
  display: flex !important;
}
.invoice-normal-details {
  .invoice-logo {
    img {
      width: auto;
      height: auto;
      max-width: 100%;
      margin-top: 10px;
    }
  }
  &__header {
    h4 {
      margin: 0 !important;
    }
  }
  &__header-table {
    border: none;
    tr,
    td {
      border: none;
      font-size: 9px;
      font-weight: bold;
    }
  }
  &__products-table {
    tr,
    td {
      font-size: 9px;
      font-weight: bold;
      text-align: center;
    }
    tfoot {
      tr {
        border-top: 1px solid #333;
      }
    }
  }
}
.paymentDitals {
  border-collapse: collapse;
  background-color: white;
  font-size: 10px;
  border-width: 1px;
  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.total-qty {
  border-width: 1px;
  border-collapse: collapse;
  background-color: white;
  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.result {
  width: 95%;
  margin: 20px auto;
  border-collapse: collapse;
  background-color: white;
  font-size: 10px;
  border-width: 1px;
  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.full-width {
  width: 100% !important;
  margin-left: 0;
  margin-right: 0;
  padding: 0 15px;
  font-size: 10px;
}
</style>
